<template>
  <div class="my-registration">
    <div class="account-card">
      <div class="account-card-header">
        <p class="account-card-title">我的报名</p>
      </div>
      <el-form
        class="order-form"
        size="mini"
        :inline="true"
        :model="registForm"
        ref="ruleForm"
        label-width="120px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="竞买进度："
              prop="biddingProgress"
            >
              <el-select v-model="registForm.biddingProgress">
                <el-option
                  v-for="item in biddingProgress"
                  :key="item.code"
                  :label="item.label"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="物资描述："
              prop="mateName"
            >
              <el-input
                v-model="registForm.mateName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="发布单位："
              prop="compName"
            >
              <el-input
                v-model="registForm.publicCompName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="form-item-box" label="公告编号：" prop="code">
              <el-input v-model="registForm.code" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="form-item-box" label="公告标题：" prop="title">
              <el-input
                v-model="registForm.title"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-date"
              label="报名日期开始："
              prop="enrollDateStart"
            >
              <el-date-picker
                type="date"
                v-model="registForm.enrollDateStart"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-end"
              label="报名日期结束："
              prop="enrollDateEnd"
            >
              <el-date-picker
                type="date"
                v-model="registForm.enrollDateEnd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="form-item-date">
            <el-form-item label="竞价日期开始：" prop="biddingDateStart">
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                v-model="registForm.biddingDateStart"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-end"
              label="竞价日期结束："
              prop="biddingDateEnd"
            >
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                v-model="registForm.biddingDateEnd"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-button size="mini" type="primary" @click="onSubmit"
              >搜索</el-button
            >
            <el-button size="mini" type="plain" @click="onResetForm('ruleForm')"
              >清空</el-button
            >
            <!-- <el-form-item class="order-form-footer">
              <el-row>
                <el-col :span="12">
                  <el-button size="mini" type="primary" @click="onSubmit"
                    >搜索</el-button
                  >
                </el-col>
                <el-col :span="12">
                  <el-button
                    size="mini"
                    type="plain"
                    @click="onResetForm('ruleForm')"
                    >清空</el-button
                  >
                </el-col>
              </el-row>
            </el-form-item> -->
          </el-col>

          <!-- <el-col :span="12">
            <el-row>
              <el-col :span="14">
                <el-form-item
                  class="form-item-date"
                  label="报名日期："
                  prop="enrollDateStart"
                >
                  <el-date-picker
                    type="date"
                    v-model="registForm.enrollDateStart"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-form-item><el-col class="line">-</el-col></el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item class="form-item-end" prop="enrollDateEnd">
                  <el-date-picker
                    type="date"
                    v-model="registForm.enrollDateEnd"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-col :span="14" class="form-item-date">
              <el-form-item label="竞价日期：" prop="biddingDateStart">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="registForm.biddingDateStart"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item><el-col class="line">-</el-col></el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item class="form-item-end" prop="biddingDateEnd">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="registForm.biddingDateEnd"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col> -->
        </el-row>
      </el-form>
    </div>
    <ul class="registration-body">
      <li v-for="item in registData" :key="item.code">
        <notice-list-item :item="item"></notice-list-item>
      </li>
    </ul>
    <el-row class="notice-pagination">
      <el-col :offset="7" :span="12">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          layout="pager, next,total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :total="pagination.total"
        >
          到第{{ pagination.pageNum }}页
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MyRegistration',
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      // key: value
      pagination: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      biddingProgress: [
        {
          label: '竞价未开始',
          code: 1
        },
        {
          label: '竞价中',
          code: 2
        },
        {
          label: '竞价已结束',
          code: 3
        }
      ],
      registForm: {
        biddingProgress: '', //竞买进度
        mateName: '', //物资描述
        enrollDateStart: '', //报名开始
        enrollDateEnd: '', //报名结束
        publicCompName: '', //发布单位
        title: '', //公告标题
        code: '',
        biddingDateStart: '', //竞价开始
        biddingDateEnd: '' //竞价结束
      },
      registData: [
        {
          imageUrl: '',
          title: '',
          enrollStatus: '',
          enrollEndTime: '',
          compName: '',
          proviceName: '',
          bidStartTime: '',
          bidEndTime: '',
          reserveWhether: '',
          depositPrice: '',
          startPrice: ''
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getEnroollList()
  },
  methods: {
    async getEnroollList() {
      let params = this.registForm
      params.pageNum = this.pagination.pageNum
      params.pageSize = this.pagination.pageSize
      this.registData = await this.$api.enrollList.getEnrollList(params)
      console.log(this.registData, '我的报名信息')
      if (
        Object.prototype.toString.apply(this.registData) !== '[object Object]'
      ) {
        this.registData = {
          data: [],
          total: 0
        }
      }
      this.pagination.total = this.registData.total
      this.registData = this.registData.data
    },
    async onSubmit() {
      let params = this.registForm
      params.pageNum = 1
      this.pagination.pageNum = 1
      params.pageSize = this.pagination.pageSize
      params.biddingProgress == '竞价未开始'
        ? (params.biddingProgress = 1)
        : params.biddingProgress == '竞价中'
        ? (params.biddingProgress = 2)
        : 3
      this.registData = await this.$api.enrollList.getEnrollList(params)
      this.pagination.total = this.registData.total
      this.registData = this.registData.data
      params.biddingProgress == 1
        ? (params.biddingProgress = '竞价未开始')
        : params.biddingProgress == 2
        ? (params.biddingProgress = '竞价中')
        : '竞价已结束'
    },
    async onResetForm(ruleForm) {
      this.$refs[ruleForm].resetFields()
      let params = this.pagination
      this.registData = await this.$api.enrollList.getEnrollList(params)
      this.pagination.total = this.registData.total
      this.registData = this.registData.data
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getEnroollList()
    },
    async handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getEnroollList()
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="less" scoped>
.my-registration {
  margin-bottom: 30px;
  .order-form {
    padding: 15px 34px;
    .el-form-item.el-form-item--mini {
      display: flex !important;
      width: 90%;
    }
    .el-button {
      font-size: 15px;
      padding: 8px 15px;
    }
    // .form-item-date {
    //   .el-form-item__content {
    //     width: 60%;
    //   }
    // }
    // .form-item-box {
    //   .el-form-item__content {
    //     width: 58%;
    //   }
    // }
    // .order-form-footer {
    //   display: flex;
    //   .el-form-item__content {
    //     width: 100%;
    //     text-align: right;
    //   }
    // }
  }
}
.user {
  display: flex;
}
</style>
